import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { EXPORT_SCORING_RESULTS_REPORT_CSV } from '../../types';
import { EXPORT_SCORING_RESULTS_REPORT_CSV_MESSAGES } from '../../constants/exportScoringResultsReportCsvMessages';
import { exportScoringResultsReportCsvPending, exportScoringResultsReportCsvFulfilled, exportScoringResultsReportCsvRejected } from '../../actions';
import { sendApiRequest, notifyError, notifyWarning } from '../../../../actions';
import generateError from '../../../../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'client/GetClientScoringsExportCsv',
  onSuccess: [response => (response.data.length === 0
    ? notifyWarning(EXPORT_SCORING_RESULTS_REPORT_CSV_MESSAGES.NOT_FOUND)
    : exportScoringResultsReportCsvFulfilled(response))],
  onError: [
    exportScoringResultsReportCsvRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'pdfApi',
};

const exportScoringResultsReportCsvEpic$ = (action$, state$) => action$.pipe(
  ofType(EXPORT_SCORING_RESULTS_REPORT_CSV.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => merge(
    of(exportScoringResultsReportCsvPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),

);

export default exportScoringResultsReportCsvEpic$;


// WEBPACK FOOTER //
// ./src/features/reports/epics/scoring-results/exportScoringResultsReportCsvEpic.js